import React from "react"
import { CheckCircle2 } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useScrollAnimation } from "../hooks/useScrollAnimation"

export default function WhyBousanm() {
    const { t } = useTranslation()
    const ref = useScrollAnimation()

    const features = [
        t('whyBousanm.feature1'),
        t('whyBousanm.feature2'),
        t('whyBousanm.feature3'),
        t('whyBousanm.feature4'),
        t('whyBousanm.feature5'),
    ]

    return (
        <section ref={ref} className="scroll-animate py-24 bg-gradient-to-br from-emerald-600 to-blue-900 overflow-hidden relative">
            <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-black/20 rounded-full blur-3xl -ml-48 -mb-48"></div>

            <div className="container mx-auto px-4 md:px-6 relative z-10">
                <div className="text-center max-w-3xl mx-auto mb-12">
                    <h2 className="text-3xl font-bold tracking-tight text-white sm:text-5xl mb-4 drop-shadow-sm">
                        {t('whyBousanm.title')}
                    </h2>
                    <p className="text-xl font-medium text-emerald-100/90 mb-6 uppercase tracking-widest">
                        {t('whyBousanm.subtitle')}
                    </p>
                </div>

                <div className="max-w-2xl mx-auto transform hover:scale-[1.02] transition-transform duration-500">
                    <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-8 md:p-12 border border-white/20">
                        <ul className="space-y-6">
                            {features.map((feature, index) => (
                                <li key={index} className="flex items-start gap-4 group">
                                    <div className="p-1 bg-emerald-100 rounded-full group-hover:bg-emerald-500 transition-colors duration-300">
                                        <CheckCircle2 className="w-5 h-5 text-emerald-600 group-hover:text-white transition-colors duration-300 flex-shrink-0" />
                                    </div>
                                    <span className="text-lg text-slate-700 font-medium">{feature}</span>
                                </li>
                            ))}
                        </ul>

                        <div className="mt-10 pt-10 border-t border-slate-100 text-center">
                            <p className="text-xl font-bold text-slate-900 italic">
                                "{t('whyBousanm.tagline')}"
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
